export const ArtifactIntegrityCopy = {
  auditEyebrow: "Evidence / Ordered events",
  overviewEvidence:
    "Create a bounded run from the live capability catalog, follow the returned run and ordered events, decide an exact-action approval, and inspect authenticated digest-verified evidence.",
  sourceBundleLegend: "Digest-bound source bundle",
  metadataMismatch:
    "Downloaded bytes did not match the application-level immutable metadata",
  panelTitle: "Artifact integrity and evidence",
  providerBoundary:
    "Integrity status reflects application-level immutable metadata and digest-verified content; it does not assert provider WORM or Object Lock.",
  verifiedState: "Application-level immutable metadata",
  downloadVerified:
    "Content length, media type and SHA-256 matched the application-level immutable metadata, providing tamper-evident content verification.",
} as const;
